import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["button"]

  connect() {
    this.audio = null
    this.isPlaying = false
  }

  play() {
    if (!this.audio) {
      this.audio = new Audio(this.urlValue)
      this.audio.addEventListener('ended', () => {
        this.isPlaying = false
        this.updateButtonState()
      })
    }

    if (this.isPlaying) {
      this.pause()
    } else {
      this.audio.play()
      this.isPlaying = true
      this.updateButtonState()
    }
  }

  toggle() {
    if (!this.audio) {
      this.audio = new Audio(this.urlValue)
      this.audio.addEventListener('ended', () => {
        this.isPlaying = false
        this.updateButtonText("Listen to my voice")
      })
    }

    if (this.isPlaying) {
      this.audio.pause()
      this.isPlaying = false
      this.updateButtonText("Listen to my voice")
    } else {
      this.audio.play()
      this.isPlaying = true
      this.updateButtonText("Pause")
    }
  }

  pause() {
    if (this.audio) {
      this.audio.pause()
      this.isPlaying = false
      this.updateButtonState()
    }
  }

  updateButtonState() {
    if (this.hasButtonTarget) {
      const icon = this.buttonTarget.querySelector('svg path')
      if (this.isPlaying) {
        // Pause icon
        icon.setAttribute('d', 'M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h1a1 1 0 001-1V8a1 1 0 00-1-1H8zM12 7a1 1 0 00-1 1v4a1 1 0 001 1h1a1 1 0 001-1V8a1 1 0 00-1-1h-1z')
      } else {
        // Play icon
        icon.setAttribute('d', 'M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z')
      }
    }
  }

  updateButtonText(text) {
    const span = this.element.querySelector('span')
    if (span) {
      span.textContent = text
    }
  }

  disconnect() {
    if (this.audio) {
      this.audio.pause()
      this.audio = null
    }
  }
}